import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import CustomBtn from "../../../components/Buttons/CustomBtn";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import SearchableTable from "../../../components/Tables/SearchableTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchStockStats } from "../../../store/Slices/StockStatsSlice";
import { StockStatsColumns } from "../../../assets/Columns/StockStatsColumns";
import AddStockModal from "../../../components/Modals/AddStockModal";
import { fetchRMStockStats } from "../../../store/Slices/RMStockStatsSlice";
import { RMStockStatsColumns } from "../../../assets/Columns/RMStockStatsColumns";
import FetchingLoading from "../../../components/Loaders/FetchingLoading";

const RMStockStat = () => {
  const [SearchText, setSearchText] = useState("");
  const [OpenAddStockModal, setOpenAddStockModal] = useState(false);

  const dispatch = useDispatch();
  const RMStockStats = useSelector((state) => state.RMStockStats);

  useEffect(() => {
    dispatch(fetchRMStockStats());
  }, [dispatch]);

  return (
    <BodyWrapper>
      <Header
        title="Raw Material Stock Statistics"
        desc="Overview of your stocks management"
      />

      <div className="w-full mt-10 flex justify-center items-center">
        {RMStockStats.loading ? (
          <div className="flex flex-1 justify-center items-center">
            <FetchingLoading />
          </div>
        ) : (
          <SearchableTable
            SearchPlaceholder={"Search Product Name..."}
            SearchText={SearchText}
            setSearchText={setSearchText}
            CurrentData={RMStockStats.data}
            Columns={RMStockStatsColumns}
          />
        )}
      </div>
    </BodyWrapper>
  );
};

export default RMStockStat;
